// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import './layerEditor';

myw.GenericTilesLayerEditor = myw.LayerEditor.extend({
    messageGroup: 'DefineLayerControl',

    formValuesToLayerDef(formValues) {
        const def = myw.LayerEditor.prototype.formValuesToLayerDef.call(this, formValues);
        delete def.url;
        _.extend(def.datasource_spec, { baseUrl: '' });
        def.relativeUrl = formValues.url;
        def.tileType = 'Raster';
        return def;
    },

    layerDefToFormValues(layerDef) {
        const values = myw.LayerEditor.prototype.layerDefToFormValues.call(this, layerDef);
        values.url = layerDef.relativeUrl;
        return values;
    }
});

myw.layerEditors['generic_tiles'] = myw.GenericTilesLayerEditor;

export default myw.GenericTilesLayerEditor;
